/**
 * @generated SignedSource<<5717462389f1acf372c2e3169c072a39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditMain_packageDate$data = {
  readonly end: string;
  readonly id: string;
  readonly price: number;
  readonly priceOld: number;
  readonly start: string;
  readonly " $fragmentType": "PackageDateEditMain_packageDate";
};
export type PackageDateEditMain_packageDate$key = {
  readonly " $data"?: PackageDateEditMain_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditMain_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditMain_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceOld",
      "storageKey": null
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "16b7cb2c4fcb1ec57629b0e32a7dba0e";

export default node;
